import * as React from "react";

import { medicalTypes } from "@teamprevent/common/healthSurveillance/models";

import { Loader } from "semantic-ui-react";

import { useCustomMedicalTypes } from "../../../customMedicalTypes/hooks/useCustomMedicalTypes";

import { CustomMedicalTypeOptions } from "../../../customMedicalTypes/models";

import { All } from "./All";
import { BaseItemExtensions } from "./BaseItemExtensions";
import { BaseRootExtensions } from "./BaseRootExtensions";
import { Create } from "./Create";
import { Detail } from "./Detail";
import { Edit } from "./Edit";

import { Fragment, Location } from "redux-little-router";

export interface BaseProps {
    medicalTypeOptions: CustomMedicalTypeOptions[];
}

const Base: React.FunctionComponent = () => {
    const { customMedicalTypes, isLoaded } = useCustomMedicalTypes();

    const withConditions = React.useCallback((l: Location) => l.params?.workGroupId === undefined, []);

    const medicalTypeOptions = React.useMemo((): CustomMedicalTypeOptions[] => {
        let mergedMedicals = medicalTypes.filter(m => !m.isObsolete).map(m => ({ text: m.name, value: m.id }));

        if (isLoaded) {
            mergedMedicals = mergedMedicals.concat(customMedicalTypes.map(m => ({ text: m.name, value: m.id })));
        }

        return mergedMedicals;
    }, [customMedicalTypes, isLoaded]);

    if (!isLoaded)
    {
        return <Loader active />;
    }

    return (
        <div>
            <Fragment forRoute="/" withConditions={withConditions}>
                <div>
                    <All />
                    <Create medicalTypeOptions={medicalTypeOptions} />
                    <BaseItemExtensions />
                </div>
            </Fragment>
            <Fragment forRoute="/:workGroupId">
                <div>
                    <Detail medicalTypeOptions={medicalTypeOptions} />
                    <Edit medicalTypeOptions={medicalTypeOptions} />
                    <BaseRootExtensions />
                </div>
            </Fragment>
        </div>
    );
};

export { Base };
